import React, { useContext } from "react";

import { Context } from "../../provider/index.js";
import languageData from "../../data/language.json";

import "../../styles/screens/general.scss";

const Header = () => {
  const { admin } = useContext(Context);
  const textData = languageData[admin.language];

  return (
    <div className="uiHeader">
      <div className="uiHeaderLogo">
        <img src="/images/logo/logoText.png" alt="border" />
      </div>

      <div className="uiHeaderBar">
        <div className="cherryContainer">
          <img
            src="/images/gameElements/heart.png"
            alt="border"
            className={`cherryImg ${admin.lives < 1 ? "hide" : ""}`}
          />
          <img
            src="/images/gameElements/heart.png"
            alt="border"
            className={`cherryImg ${admin.lives < 2 ? "hide" : ""}`}
          />
          <img
            src="/images/gameElements/heart.png"
            alt="border"
            className={`cherryImg ${admin.lives < 3 ? "hide" : ""}`}
          />

          {admin.mode == "speed" && (
            <div className="uiHeaderMode uiHeaderMode__speed">
              <img src="/images/gameElements/speed.png" />

              <span>SPEED</span>
            </div>
          )}

          {admin.mode == "slow" && (
            <div className="uiHeaderMode">
              <img src="/images/gameElements/slow.png" />

              <span>SLOW</span>
            </div>
          )}
        </div>

        <div className="scoreContainer">
          <h3 className="level">
            {textData.explPage.level} {admin.level}
          </h3>
          <h3 className="highscore">
            {textData.explPage.score}{" "}
            <span>{("000000" + admin.highScore).slice(-6)}</span>
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Header;
